(() => {
  if (window.__koziolOfferPdfInitialized) return;
  window.__koziolOfferPdfInitialized = true;

  function getConfig() {
    return window.koziolOffer || null;
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function getForm(config) {
    if (!config || !config.formId) return null;

    return document.getElementById(config.formId);
  }

  function getScope(config, button) {
    const form = getForm(config);

    return (
      button.closest('.product-info') ||
      form?.closest('.product-info') ||
      document.querySelector('.product-info') ||
      document
    );
  }

  function normalizeWhitespace(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseInteger(value, fallback) {
    const parsed = parseInt(value, 10);

    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function parseNumber(value) {
    if (value == null) return null;

    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    const normalized = String(value).trim().replace(',', '.');
    if (!normalized) return null;

    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function normalizeMoneyValue(value) {
    const parsed = parseNumber(value);

    if (!Number.isFinite(parsed) || parsed === 0) return 0;

    if (parsed > 0 && parsed < 1000) {
      return Math.round(parsed * 100);
    }

    return Math.round(parsed);
  }

  function isTruthyValue(value) {
    if (value === true) return true;
    if (value === false || value == null) return false;

    if (typeof value === 'number') {
      return value === 1;
    }

    const normalized = normalizeWhitespace(value).toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
  }

  function parseCurrencyToCents(text) {
    const normalized = normalizeWhitespace(text);
    if (!normalized) return null;

    const match = normalized.match(/-?\d{1,3}(?:[.\s]\d{3})*(?:,\d+)?|-?\d+(?:,\d+)?/);
    if (!match) return null;

    const numeric = match[0].replace(/\s/g, '').replace(/\./g, '').replace(',', '.');
    const parsed = parseFloat(numeric);

    if (!Number.isFinite(parsed)) return null;

    return Math.round(parsed * 100);
  }

  function getMultiplier(type) {
    const value = window.themeVariables?.pricingDiscounts?.multipliers?.[type];
    const parsed = parseNumber(value);

    return parsed && parsed > 0 ? parsed : 1;
  }

  function formatMoney(cents, currency) {
    if (!Number.isFinite(cents)) return '';

    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency || 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  }

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  function parseJsonScript(element, selector) {
    const script = element?.querySelector(selector);
    if (!script) return {};

    try {
      const parsed = JSON.parse(script.textContent || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function getSelectedFinishVariantId(config) {
    if (!config?.formId) return null;

    const dropdowns = Array.from(
      document.querySelectorAll(
        `[data-koziol-finish-dropdown][data-form-id="${escapeSelector(
          config.formId
        )}"][data-selected-variant-id]`
      )
    );
    const selectedDropdown = dropdowns.find((dropdown) => {
      const block = dropdown.closest('[data-finish-dropdown-block]');

      return (
        dropdown.getAttribute('data-finish-dropdown-type') !== 'set' &&
        !dropdown.hasAttribute('data-koziol-unselected') &&
        block &&
        !block.hasAttribute('hidden')
      );
    });

    return selectedDropdown?.getAttribute('data-selected-variant-id') || null;
  }

  function getCurrentVariant(config, form) {
    const variants = Array.isArray(config?.product?.variants) ? config.product.variants : [];
    const input = form?.querySelector('input[name="id"]');
    const candidateIds = [
      getSelectedFinishVariantId(config),
      input?.value,
      new URLSearchParams(window.location.search).get('variant'),
      variants[0]?.id,
    ];

    for (const candidate of candidateIds) {
      const variantId = parseInteger(candidate, NaN);
      if (!Number.isFinite(variantId)) continue;

      const match = variants.find((variant) => variant.id === variantId);
      if (match) return match;
    }

    return variants[0] || null;
  }

  function getVariantImageUrl(config, variant) {
    const variants = Array.isArray(config?.product?.variants)
      ? config.product.variants
      : [];
    const variantImageUrls = config?.variantImageUrls || {};
    const variantId = variant?.id == null ? null : String(variant.id);
    const variantImageUrl = variantId ? variantImageUrls[variantId] : null;

    if (variantImageUrl) return variantImageUrl;

    const colorOptionIndex = parseInteger(config?.colorOptionPosition, 0) - 1;
    const selectedColor = variant?.options?.[colorOptionIndex];

    if (colorOptionIndex >= 0 && selectedColor) {
      const matchingColorVariant = variants.find((candidate) => {
        return (
          candidate?.options?.[colorOptionIndex] === selectedColor &&
          variantImageUrls[String(candidate.id)]
        );
      });

      if (matchingColorVariant) {
        return variantImageUrls[String(matchingColorVariant.id)];
      }
    }

    return config?.firstImageUrl || null;
  }

  function getQuantity(config, scope) {
    const form = getForm(config);
    const quantityInput =
      scope.querySelector(
        `#${escapeSelector(config.formId)}-quantity`
      ) ||
      form?.querySelector('input.quantity-selector__input[name="quantity"]') ||
      scope.querySelector('input.quantity-selector__input[name="quantity"]') ||
      scope.querySelector('input[name="quantity"]');

    const quantity = parseInteger(quantityInput?.value, 1);
    return quantity > 0 ? quantity : 1;
  }

  function getSelectedSummary(scope) {
    return scope.querySelector('[data-pricing-summary]');
  }

  function getTextValue(root, selector) {
    const element = root?.querySelector(selector);
    return normalizeWhitespace(element?.textContent || '');
  }

  function getOwnTextValue(root, selector) {
    const element = root?.querySelector(selector);
    if (!element) return '';

    const ownText = Array.from(element.childNodes)
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => node.textContent || '')
      .join(' ');

    return normalizeWhitespace(ownText);
  }

  function getProductUnitPriceCents(config, scope, quantity) {
    const summary = getSelectedSummary(scope);

    if (summary) {
      const subtotal = parseCurrencyToCents(
        getTextValue(summary, '[data-pricing-value="product"]')
      );

      if (Number.isFinite(subtotal) && quantity > 0) {
        return Math.round(subtotal / quantity);
      }
    }

    const salePriceText = getTextValue(scope, '.product-info__price price-list sale-price');
    return parseCurrencyToCents(salePriceText);
  }

  function getTaxNotice(scope) {
    return (
      getTextValue(scope, '.koziol-pricing-summary__sub-label') ||
      getTextValue(scope, '.product-info__price .text-sm.text-subdued')
    );
  }

  function getPricingLabels(scope, i18n) {
    const summary = getSelectedSummary(scope);

    return {
      total:
        getOwnTextValue(summary, '.koziol-pricing-summary__label--total') ||
        i18n.totalPrice,
      allIn:
        getTextValue(summary, '.koziol-pricing-summary__label--all-in') || i18n.allInPricePerPiece,
      setup:
        getTextValue(summary, '[data-pricing-row="setup"] .koziol-pricing-summary__label') ||
        i18n.printingCosts,
    };
  }

  function getI18n(config) {
    return config?.translations && typeof config.translations === 'object' ? config.translations : {};
  }

  function isFinishOptionName(name) {
    const normalized = normalizeWhitespace(name).toLowerCase();

    return normalized.includes('veredel') || normalized.includes('finish');
  }

  function getOptionLines(config, variant) {
    const lines = [];
    const optionNames = Array.isArray(config?.optionNames) ? config.optionNames : [];
    const optionValues = Array.isArray(variant?.options) ? variant.options : [];

    optionNames.forEach((optionName, index) => {
      const value = optionValues[index];
      if (!optionName || !value) return;

      lines.push({
        label: optionName,
        value,
      });
    });

    return lines;
  }

  function findTierPrice(tiers, quantity) {
    if (!Array.isArray(tiers) || !tiers.length) return null;

    let price = null;

    tiers.forEach((tier) => {
      const minQuantity = parseInteger(
        tier?.min_qty ?? tier?.min ?? tier?.minQuantity ?? tier?.minimumQuantity,
        0
      );

      if (quantity >= minQuantity) {
        price = tier?.price;
      }
    });

    return price;
  }

  function getSelectedFinishRows(config, scope, quantity, i18n) {
    const dropdowns = Array.from(
      document.querySelectorAll(
        `[data-koziol-finish-dropdown][data-form-id="${escapeSelector(config.formId)}"]`
      )
    ).filter((dropdown) => {
      const block = dropdown.closest('[data-finish-dropdown-block]');
      return block && !block.hasAttribute('hidden');
    });

    const missingSelections = [];
    const detailLines = [];
    const tableRows = [];
    const setFinishTitles = [];

    dropdowns.forEach((dropdown) => {
      if (dropdown.hasAttribute('data-koziol-unselected')) {
        const block = dropdown.closest('[data-finish-dropdown-block]');
        const label =
          block?.getAttribute('data-set-component-label') ||
          getTextValue(block, '.koziol-pdp-dropdown-block__heading') ||
          i18n.finish;

        missingSelections.push(label);
        return;
      }

      const block = dropdown.closest('[data-finish-dropdown-block]');
      const selectedVariantId = dropdown.getAttribute('data-selected-variant-id');
      const variantMap = parseJsonScript(block, 'script[data-finish-variants]');
      const variantData = selectedVariantId ? variantMap[String(selectedVariantId)] : null;
      const componentLabel = block?.getAttribute('data-set-component-label') || '';
      const finishTitle =
        normalizeWhitespace(variantData?.title) ||
        normalizeWhitespace(dropdown.querySelector('.koziol-pdp-dropdown__form-label-text')?.textContent) ||
        normalizeWhitespace(dropdown.querySelector('.koziol-pdp-dropdown__form-label')?.textContent) ||
        i18n.finish;
      const finishSubtitle =
        normalizeWhitespace(variantData?.subtitle) ||
        normalizeWhitespace(dropdown.querySelector('.koziol-pdp-dropdown__form-label-subtitle')?.textContent);
      const detailLabel = componentLabel || i18n.finish;
      const detailValue = finishSubtitle ? `${finishTitle} (${finishSubtitle})` : finishTitle;

      detailLines.push({
        label: detailLabel,
        value: detailValue,
      });

      if (dropdown.getAttribute('data-finish-dropdown-type') === 'set') {
        setFinishTitles.push(finishTitle);
      }

      const finishPrice = findTierPrice(variantData?.tiers || [], quantity);
      const unitPriceCents =
        finishPrice == null
          ? null
          : Math.round(normalizeMoneyValue(finishPrice) * getMultiplier('finish'));
      const setupFeeRaw = variantData?.setupFee;
      const setupFeeCents =
        setupFeeRaw == null
          ? 0
          : Math.round(normalizeMoneyValue(setupFeeRaw) * getMultiplier('setup'));
      const tableLabel = componentLabel ? `${componentLabel}: ${finishTitle}` : finishTitle;

      tableRows.push({
        quantity,
        label: tableLabel,
        hideInPdf: variantData?.isNoFinish === true,
        unitPriceCents,
        subtotalCents: unitPriceCents == null ? null : unitPriceCents * quantity,
      });

      if (setupFeeCents > 0) {
        tableRows.push({
          quantity: 1,
          label: componentLabel ? `${componentLabel}: ${i18n.printingCosts}` : i18n.printingCosts,
          unitPriceCents: setupFeeCents,
          subtotalCents: setupFeeCents,
        });
      }
    });

    return {
      missingSelections,
      detailLines,
      tableRows,
      setFinishTitles,
    };
  }

  function getPricingSummaryValues(scope) {
    const summary = getSelectedSummary(scope);
    if (!summary) return {};

    return {
      product: parseCurrencyToCents(getTextValue(summary, '[data-pricing-value="product"]')),
      finish: parseCurrencyToCents(getTextValue(summary, '[data-pricing-value="finish"]')),
      setup: parseCurrencyToCents(getTextValue(summary, '[data-pricing-value="setup"]')),
      total: parseCurrencyToCents(getTextValue(summary, '[data-pricing-value="total"]')),
      allIn: parseCurrencyToCents(getTextValue(summary, '[data-pricing-value="allIn"]')),
    };
  }

  async function loadImageAsDataUrl(src) {
    if (!src) return null;

    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.decoding = 'async';

    return new Promise((resolve) => {
      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = image.naturalWidth;
          canvas.height = image.naturalHeight;

          const context = canvas.getContext('2d');
          context.drawImage(image, 0, 0);

          resolve({
            dataUrl: canvas.toDataURL('image/png'),
            format: 'PNG',
            width: image.naturalWidth,
            height: image.naturalHeight,
          });
        } catch (error) {
          resolve(null);
        }
      };

      image.onerror = () => resolve(null);
      image.src = src;
    });
  }

  function getWrappedLines(doc, text, width) {
    const content = String(text || '').replace(/\r/g, '').trim();
    if (!content) return [];

    return content.split('\n').reduce((lines, paragraph, index) => {
      const trimmedParagraph = paragraph.trim();

      if (index > 0 && lines.length) {
        lines.push('');
      }

      if (!trimmedParagraph) {
        return lines;
      }

      return lines.concat(doc.splitTextToSize(trimmedParagraph, width));
    }, []);
  }

  function getParagraphLines(doc, text, width) {
    return String(text || '')
      .replace(/\r/g, '')
      .split('\n')
      .map((paragraph) => paragraph.trim())
      .filter(Boolean)
      .map((paragraph) => doc.splitTextToSize(paragraph, width));
  }

  function addWrappedText(doc, text, x, y, width, lineHeight) {
    const lines = getWrappedLines(doc, text, width);
    if (!lines.length) return y;

    doc.text(lines, x, y);

    return y + lines.length * lineHeight;
  }

  function addParagraphText(doc, text, x, y, width, lineHeight, paragraphGap) {
    const paragraphs = getParagraphLines(doc, text, width);
    if (!paragraphs.length) return y;

    paragraphs.forEach((paragraphLines, index) => {
      doc.text(paragraphLines, x, y);
      y += paragraphLines.length * lineHeight;

      if (index < paragraphs.length - 1) {
        y += paragraphGap;
      }
    });

    return y;
  }

  function getTextBlockHeight(doc, text, width, lineHeight) {
    return getWrappedLines(doc, text, width).length * lineHeight;
  }

  function isHtmlContent(value) {
    return /<[^>]+>/.test(String(value || ''));
  }

  function getTextBlocks(value) {
    const raw = String(value || '').trim();
    if (!raw) return [];

    const plainBlocks = raw
      .replace(/\r/g, '')
      .split('\n')
      .map((line) => normalizeWhitespace(line))
      .filter(Boolean)
      .map((text) => ({ text, bold: false }));

    if (!isHtmlContent(raw) || typeof DOMParser === 'undefined') {
      return plainBlocks;
    }

    const parsed = new DOMParser().parseFromString(
      raw.replace(/<br\s*\/?>/gi, '</p><p>'),
      'text/html'
    );
    const blocks = [];

    function pushBlock(text, bold, prefix = '') {
      const normalized = normalizeWhitespace(`${prefix}${text || ''}`);
      if (!normalized) return;

      blocks.push({
        text: normalized,
        bold: bold === true,
      });
    }

    function isEntirelyBold(node) {
      const meaningfulChildren = Array.from(node.childNodes).filter((child) => {
        if (child.nodeType !== Node.TEXT_NODE) return true;
        return normalizeWhitespace(child.textContent).length > 0;
      });

      if (!meaningfulChildren.length) return false;

      return meaningfulChildren.every((child) => {
        if (child.nodeType !== Node.ELEMENT_NODE) return false;

        const tag = child.tagName.toLowerCase();
        return tag === 'strong' || tag === 'b';
      });
    }

    function collectBlocks(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        pushBlock(node.textContent, false);
        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return;

      const tag = node.tagName.toLowerCase();

      if (tag === 'ul' || tag === 'ol') {
        Array.from(node.children).forEach((item) => {
          pushBlock(item.textContent, isEntirelyBold(item), '• ');
        });
        return;
      }

      if (tag === 'div') {
        const hasBlockChildren = Array.from(node.children).some((child) => {
          const childTag = child.tagName.toLowerCase();
          return (
            childTag === 'p' ||
            childTag === 'div' ||
            childTag === 'ul' ||
            childTag === 'ol' ||
            childTag === 'li' ||
            /^h[1-6]$/.test(childTag)
          );
        });

        if (hasBlockChildren) {
          Array.from(node.childNodes).forEach(collectBlocks);
          return;
        }
      }

      if (
        tag === 'p' ||
        tag === 'div' ||
        tag === 'li' ||
        /^h[1-6]$/.test(tag)
      ) {
        pushBlock(node.textContent, /^h[1-6]$/.test(tag) || isEntirelyBold(node));
        return;
      }

      if (tag === 'strong' || tag === 'b') {
        pushBlock(node.textContent, true);
        return;
      }

      Array.from(node.childNodes).forEach(collectBlocks);
    }

    Array.from(parsed.body.childNodes).forEach(collectBlocks);

    if (blocks.length) return blocks;

    const fallbackText = normalizeWhitespace(parsed.body.textContent || '');
    return fallbackText ? [{ text: fallbackText, bold: false }] : plainBlocks;
  }

  function renderLabeledTextBlock(doc, label, text, x, y, width, lineHeight, palette) {
    const blocks = getTextBlocks(text);
    if (!blocks.length) return y;

    doc.setFontSize(7.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...palette.ink);

    const shouldRenderInline =
      blocks.length === 1 &&
      blocks[0].bold !== true &&
      !isHtmlContent(text);

    if (shouldRenderInline) {
      const labelStr = `${label}: `;
      const labelW = doc.getTextWidth(labelStr);
      doc.text(labelStr, x, y);

      doc.setFont('helvetica', 'normal');

      const flatText = blocks[0].text;
      const firstLineMaxW = Math.max(width - labelW, 0);
      const words = flatText.split(' ').filter(Boolean);
      const firstLineWords = [];
      let consumed = 0;

      for (let i = 0; i < words.length; i++) {
        const testLine = firstLineWords.concat(words[i]).join(' ');
        if (doc.getTextWidth(testLine) <= firstLineMaxW) {
          firstLineWords.push(words[i]);
          consumed = i + 1;
        } else {
          break;
        }
      }

      if (firstLineWords.length) {
        doc.text(firstLineWords.join(' '), x + labelW, y);
        y += lineHeight;
      } else {
        y += lineHeight;
        const lines = doc.splitTextToSize(flatText, width);
        doc.text(lines, x, y);
        return y + lines.length * lineHeight;
      }

      if (consumed < words.length) {
        const remaining = words.slice(consumed).join(' ');
        const restLines = doc.splitTextToSize(remaining, width);
        doc.text(restLines, x, y);
        y += restLines.length * lineHeight;
      }

      return y;
    }

    doc.text(`${label}:`, x, y);
    y += lineHeight;

    blocks.forEach((block, index) => {
      doc.setFont('helvetica', block.bold ? 'bold' : 'normal');
      doc.setFontSize(7.5);
      doc.setTextColor(...palette.ink);
      y = addWrappedText(doc, block.text, x, y, width, lineHeight);

      if (index < blocks.length - 1) {
        y += block.bold ? 1.2 : 0.8;
      }
    });

    return y;
  }

  function ensureSpace(doc, y, needed) {
    const pageH = doc.internal.pageSize.getHeight();
    if (y + needed > pageH - 10) {
      doc.addPage();
      return 14;
    }
    return y;
  }

  function shouldHidePriceOverviewRow(row, index) {
    if (index === 0 || !row) return false;

    const hasZeroPricing =
      row.unitPriceCents === 0 &&
      row.subtotalCents === 0;

    return hasZeroPricing || isTruthyValue(row.hideInPdf);
  }

  function getDetailRowsHeight(doc, lines, labelWidth, valueWidth) {
    const lineHeight = 3.8;
    const rowGap = 1.2;

    return lines.reduce((total, line) => {
      const labelLines = getWrappedLines(doc, line.label, labelWidth);
      const valueLines = getWrappedLines(doc, line.value, valueWidth);
      const rowLineCount = Math.max(labelLines.length || 1, valueLines.length || 1);

      return total + rowLineCount * lineHeight + rowGap;
    }, 0);
  }

  function renderDetailRows(doc, lines, x, y, labelWidth, valueWidth, palette) {
    const lineHeight = 3.8;
    const rowGap = 1.2;
    const valueX = x + labelWidth + 3;

    lines.forEach((line) => {
      const labelLines = getWrappedLines(doc, line.label, labelWidth);
      const valueLines = getWrappedLines(doc, line.value, valueWidth);
      const rowLineCount = Math.max(labelLines.length || 1, valueLines.length || 1);
      const rowHeight = rowLineCount * lineHeight;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.setTextColor(...palette.muted);
      doc.text(labelLines.length ? labelLines : [''], x, y);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.setTextColor(...palette.ink);
      doc.text(valueLines.length ? valueLines : [''], valueX, y);

      y += rowHeight + rowGap;
    });

    return y;
  }

  function getFittedImageDimensions(image, maxWidth, maxHeight) {
    const imageWidth = image?.width;
    const imageHeight = image?.height;

    if (!Number.isFinite(imageWidth) || !Number.isFinite(imageHeight) || imageWidth <= 0 || imageHeight <= 0) {
      return {
        width: maxWidth,
        height: maxHeight,
      };
    }

    const scale = Math.min(maxWidth / imageWidth, maxHeight / imageHeight);

    return {
      width: imageWidth * scale,
      height: imageHeight * scale,
    };
  }

  function buildPdf(config, data, imageData, logoData) {
    const i18n = getI18n(config);
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ unit: 'mm', format: 'a4' });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const ml = 18;
    const mr = 18;
    const cw = pageWidth - ml - mr;
    const palette = {
      ink: [33, 37, 41],
      muted: [108, 117, 125],
      label: [73, 80, 87],
      accent: [44, 62, 80],
      border: [222, 226, 230],
      lightBg: [248, 249, 250],
      white: [255, 255, 255],
      tableHead: [248, 249, 250],
      tableHeadText: [33, 37, 41],
      tableBorder: [233, 236, 239],
    };
    const footerLineHeight = 3.2;
    const footerBlockGap = 2;
    const footerSectionPadding = 4;
    const deliveryParagraphGap = 0.8;

    let y = 14;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(17);
    doc.setTextColor(...palette.ink);
    doc.text(config.pdfTitle || i18n.onlineOffer, ml, y);

    if (logoData) {
      const logoMaxW = 35;
      const logoMaxH = 14;
      const fitted = getFittedImageDimensions(logoData, logoMaxW, logoMaxH);
      const logoX = ml + cw - fitted.width;
      const logoY = y - fitted.height + 2;
      doc.addImage(logoData.dataUrl, logoData.format || 'JPEG', logoX, logoY, fitted.width, fitted.height);
    }

    y += 4.5;

    if (config.pdfIntroText) {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.setTextColor(...palette.muted);
      y = addWrappedText(doc, config.pdfIntroText, ml, y, cw, 3.6);
      y += 1.5;
    }

    doc.setDrawColor(...palette.accent);
    doc.setLineWidth(0.5);
    doc.line(ml, y, ml + cw, y);
    y += 5;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7.5);
    doc.setTextColor(...palette.muted);
    doc.text(i18n.date, ml, y);
    doc.text(i18n.validUntil, ml + 40, y);
    y += 3.5;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...palette.ink);
    doc.text(data.formattedToday, ml, y);
    doc.text(data.formattedValidUntil, ml + 40, y);
    y += 6;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(...palette.accent);
    doc.text(i18n.offerDetails, ml, y);
    y += 5.5;

    const imagePanelW = imageData ? 36 : 0;
    const imageGap = imageData ? 6 : 0;
    const detailLabelW = 28;
    const detailValueW = cw - detailLabelW - 3 - imagePanelW - imageGap;
    const detailContentH = getDetailRowsHeight(doc, data.detailLines, detailLabelW, detailValueW);
    const imagePanelH = imageData ? Math.max(36, detailContentH) : 0;
    const detailBlockH = Math.max(detailContentH, imagePanelH);

    renderDetailRows(doc, data.detailLines, ml, y, detailLabelW, detailValueW, palette);

    if (imageData) {
      const imgBoxX = ml + cw - imagePanelW;
      const imgBoxY = y - 2;
      const pad = 2;
      const fitted = getFittedImageDimensions(imageData, imagePanelW - pad * 2, imagePanelH - pad * 2);
      const imgX = imgBoxX + (imagePanelW - fitted.width) / 2;
      const imgY = imgBoxY + (imagePanelH - fitted.height) / 2;

      doc.addImage(imageData.dataUrl, imageData.format || 'JPEG', imgX, imgY, fitted.width, fitted.height);
    }

    y += detailBlockH + 5;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(...palette.accent);
    doc.text(i18n.priceOverview, ml, y);
    y += 6;

    const showPrices = config.showPrices === true;

    doc.autoTable({
      startY: y,
      margin: { left: ml, right: mr },
      head: [showPrices
        ? [i18n.qty, i18n.article, i18n.unitPrice, i18n.subtotal]
        : [i18n.qty, i18n.article],
      ],
      body: data.tableRows.filter((row, idx) => !shouldHidePriceOverviewRow(row, idx)).map((row) => {
        const qty = String(row.quantity);
        const label = row.label;
        if (!showPrices) return [qty, label];

        return [
          qty,
          label,
          Number.isFinite(row.unitPriceCents) ? formatMoney(row.unitPriceCents, config.currency) : '',
          Number.isFinite(row.subtotalCents) ? formatMoney(row.subtotalCents, config.currency) : '',
        ];
      }),
      theme: 'plain',
      styles: {
        font: 'helvetica',
        fontSize: 8.5,
        textColor: palette.ink,
        cellPadding: { top: 1.8, right: 2.5, bottom: 1.8, left: 2.5 },
        lineColor: palette.tableBorder,
        lineWidth: 0,
        valign: 'middle',
        overflow: 'linebreak',
      },
      headStyles: {
        fillColor: palette.tableHead,
        textColor: palette.tableHeadText,
        fontStyle: 'bold',
        fontSize: 7.5,
      },
      columnStyles: showPrices ? {
        0: { cellWidth: 14 },
        1: { cellWidth: cw - 14 - 28 - 30 },
        2: { cellWidth: 28 },
        3: { cellWidth: 30 },
      } : {
        0: { cellWidth: 14 },
        1: { cellWidth: cw - 14 },
      },
      didParseCell: (hookData) => {
        const col = hookData.column.index;
        if (col === 0) hookData.cell.styles.halign = 'center';
        if (showPrices && (col === 2 || col === 3)) hookData.cell.styles.halign = 'right';

        if (hookData.section === 'body' && hookData.row.index === 0) {
          hookData.cell.styles.fontStyle = 'bold';
        }
      },
      didDrawCell: (hookData) => {
        if (hookData.section === 'head') {
          const cellY = hookData.cell.y + hookData.cell.height;
          doc.setDrawColor(...palette.accent);
          doc.setLineWidth(0.3);
          doc.line(ml, cellY, ml + cw, cellY);
        }

        if (hookData.section === 'body' && hookData.column.index === 0) {
          const isLastRow = hookData.row.index === hookData.table.body.length - 1;
          if (!isLastRow) {
            const cellY = hookData.cell.y + hookData.cell.height;
            doc.setDrawColor(...palette.tableBorder);
            doc.setLineWidth(0.1);
            doc.line(ml, cellY, ml + cw, cellY);
          }
        }
      },
    });

    let ty = doc.lastAutoTable.finalY + 5;

    if (showPrices) {
      doc.setDrawColor(...palette.accent);
      doc.setLineWidth(0.3);
      const totalsW = 72;
      const totalsX = ml + cw - totalsW;
      doc.line(totalsX, ty, ml + cw, ty);
      ty += 4.5;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.setTextColor(...palette.label);
      doc.text(data.pricingLabels.total, totalsX, ty);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.setTextColor(...palette.ink);
      doc.text(formatMoney(data.totalCents, config.currency), ml + cw, ty, { align: 'right' });
      ty += 4.5;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.setTextColor(...palette.label);
      doc.text(data.pricingLabels.allIn, totalsX, ty);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.setTextColor(...palette.ink);
      doc.text(formatMoney(data.allInCents, config.currency), ml + cw, ty, { align: 'right' });
      ty += 2;

      if (data.taxNotice) {
        ty += 2;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.setTextColor(...palette.muted);
        ty = addWrappedText(doc, data.taxNotice, totalsX, ty, totalsW, 3.2);
      }
    }

    let fy = ty + 8;

    if (i18n.roundingNotice) {
      fy = ensureSpace(doc, fy, 8);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(6.5);
      doc.setTextColor(...palette.muted);
      fy = addWrappedText(doc, i18n.roundingNotice, ml, fy, cw, 3);
    }

    if (config.pdfPrintSampleText || config.pdfPaymentTermsText) {
      fy = ensureSpace(doc, fy, 18);
      doc.setDrawColor(...palette.border);
      doc.setLineWidth(0.15);
      doc.line(ml, fy, ml + cw, fy);
      fy += footerSectionPadding;

      if (config.pdfPrintSampleText) {
        fy = renderLabeledTextBlock(
          doc, i18n.printSampleLabel || 'Andruckmuster',
          config.pdfPrintSampleText, ml, fy, cw, footerLineHeight, palette
        );
        fy += footerBlockGap;
      }

      if (config.pdfPaymentTermsText) {
        fy = renderLabeledTextBlock(
          doc, i18n.paymentTermsLabel || 'Zahlungsbedingungen',
          config.pdfPaymentTermsText, ml, fy, cw, footerLineHeight, palette
        );
        fy += footerBlockGap;
      }
    }

    if (config.pdfShippingConditionsText || config.pdfDeliveryText || config.pdfOverUnderDeliveryText) {
      fy = ensureSpace(doc, fy, 22);
      doc.setDrawColor(...palette.border);
      doc.setLineWidth(0.15);
      doc.line(ml, fy, ml + cw, fy);
      fy += footerSectionPadding;

      if (config.pdfShippingConditionsText) {
        fy = renderLabeledTextBlock(
          doc, i18n.shippingConditionsLabel || 'Lieferbedingungen',
          config.pdfShippingConditionsText, ml, fy, cw, footerLineHeight, palette
        );
        fy += footerBlockGap;
      }

      if (config.pdfDeliveryText) {
        const deliveryText = (config.pdfDeliveryText || '').replace(/^Lieferzeiten:\s*/i, '');
        if (deliveryText) {
          fy = ensureSpace(doc, fy, 16);
          const dtLabel = i18n.deliveryTimesLabel || 'Lieferzeiten';
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(7.5);
          doc.setTextColor(...palette.ink);
          doc.text(dtLabel, ml, fy);
          fy += 3.5;

          doc.setFont('helvetica', 'normal');
          doc.setFontSize(7.5);
          doc.setTextColor(...palette.ink);
          fy = addParagraphText(doc, deliveryText, ml, fy, cw, footerLineHeight, deliveryParagraphGap);
          fy += footerBlockGap;
        }
      }

      if (config.pdfOverUnderDeliveryText) {
        fy = ensureSpace(doc, fy, 12);
        fy = renderLabeledTextBlock(
          doc, i18n.overUnderDeliveryLabel || 'Über-/Unterlieferung',
          config.pdfOverUnderDeliveryText, ml, fy, cw, footerLineHeight, palette
        );
        fy += footerBlockGap;
      }
    }

    fy = ensureSpace(doc, fy, 12);
    doc.setDrawColor(...palette.border);
    doc.setLineWidth(0.15);
    doc.line(ml, fy, ml + cw, fy);
    fy += 4;

    if (config.pdfAgbUrl) {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7.5);
      doc.setTextColor(...palette.ink);
      const agbText = config.pdfAgbLabel || i18n.agbLabel || 'AGB';
      doc.textWithLink(agbText, ml, fy, { url: config.pdfAgbUrl });
      const agbW = doc.getTextWidth(agbText);
      doc.setDrawColor(...palette.ink);
      doc.setLineWidth(0.15);
      doc.line(ml, fy + 0.5, ml + agbW, fy + 0.5);
      fy += 4;
    }

    if (config.pdfAdditionalText) {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(6.5);
      doc.setTextColor(...palette.muted);
      addWrappedText(doc, config.pdfAdditionalText, ml, fy, cw, 3);
    }

    return doc;
  }

  async function generateOfferPdf(button) {
    const config = getConfig();
    const i18n = getI18n(config);

    if (!config || !window.jspdf) {
      throw new Error(i18n.noLibrary || 'Offer PDF is not available.');
    }

    const form = getForm(config);
    const scope = getScope(config, button);
    const variant = getCurrentVariant(config, form);

    if (!variant) {
      throw new Error(i18n.noVariant);
    }

    const quantity = getQuantity(config, scope);
    const finishData = getSelectedFinishRows(config, scope, quantity, i18n);

    if (finishData.missingSelections.length) {
      throw new Error(
        `${i18n.missingSelection}: ${finishData.missingSelections.join(', ')}`
      );
    }

    const pricingSummary = getPricingSummaryValues(scope);
    const pricingLabels = getPricingLabels(scope, i18n);
    const productUnitPriceCents = getProductUnitPriceCents(config, scope, quantity);
    const productSubtotalCents = Number.isFinite(pricingSummary.product)
      ? pricingSummary.product
      : Number.isFinite(productUnitPriceCents)
        ? productUnitPriceCents * quantity
        : 0;
    const productRow = {
      quantity,
      label: config.product?.title || variant?.name || i18n.product,
      unitPriceCents: Number.isFinite(productUnitPriceCents) ? productUnitPriceCents : null,
      subtotalCents: Number.isFinite(productSubtotalCents) ? productSubtotalCents : null,
    };
    const tableRows = [productRow, ...finishData.tableRows];
    const totalFromRows = tableRows.reduce((sum, row) => {
      return sum + (Number.isFinite(row.subtotalCents) ? row.subtotalCents : 0);
    }, 0);
    const totalCents = Number.isFinite(pricingSummary.total) ? pricingSummary.total : totalFromRows;
    const allInCents =
      Number.isFinite(pricingSummary.allIn) && pricingSummary.allIn > 0
        ? pricingSummary.allIn
        : quantity > 0
          ? Math.round(totalCents / quantity)
          : 0;
    const optionLines = getOptionLines(config, variant);
    const setFinishSummary = finishData.setFinishTitles
      .filter((title, index, titles) => title && titles.indexOf(title) === index)
      .join(', ');

    if (setFinishSummary) {
      optionLines.forEach((line) => {
        if (isFinishOptionName(line.label)) {
          line.value = setFinishSummary;
        }
      });
    }

    const detailLines = [
      { label: i18n.articleLabel, value: config.product?.title || variant?.name || '' },
      ...optionLines,
      { label: i18n.articleNo, value: variant.sku || '' },
    ];

    if (config.packagingUnitText) {
      detailLines.push({
        label: i18n.ve,
        value: config.packagingUnitText,
      });
    }

    detailLines.push({
      label: i18n.quantity,
      value: String(quantity),
    });

    detailLines.push(...finishData.detailLines);

    const today = new Date();
    const validUntil = new Date(today);
    validUntil.setDate(today.getDate() + 28);

    const [imageDataUrl, logoDataUrl] = await Promise.all([
      loadImageAsDataUrl(getVariantImageUrl(config, variant)),
      loadImageAsDataUrl(config.pdfLogoUrl),
    ]);

    return buildPdf(
      config,
      {
        detailLines: detailLines.filter((line) => normalizeWhitespace(line.value)),
        tableRows,
        pricingLabels,
        totalCents,
        allInCents,
        taxNotice: getTaxNotice(scope),
        formattedToday: formatDate(today),
        formattedValidUntil: formatDate(validUntil),
      },
      imageDataUrl,
      logoDataUrl
    );
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    button.toggleAttribute('disabled', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-offer-button="true"]');
    if (!button) return;

    event.preventDefault();

    const previewWindow = window.open('', '_blank');
    setButtonLoading(button, true);

    try {
      const doc = await generateOfferPdf(button);
      const blob = doc.output('blob');
      const blobUrl = URL.createObjectURL(blob);

      if (previewWindow) {
        previewWindow.location.href = blobUrl;
      } else {
        window.open(blobUrl, '_blank');
      }

      window.setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 60 * 1000);
    } catch (error) {
      if (previewWindow) {
        previewWindow.close();
      }

      const i18n = getI18n(getConfig());
      window.alert(error instanceof Error ? error.message : i18n.genericError || 'The offer PDF could not be generated.');
    } finally {
      setButtonLoading(button, false);
    }
  });
})();
